import React, { useEffect } from 'react';

const TableFooter = props => {
	const { files } = props;
	const [, updateState] = React.useState();
	const forceUpdate = React.useCallback(() => { return updateState({}); }, []);
	function onUpdate() { forceUpdate(); }
	function getStats() {
		return files.reduce((acc, curr) => {
			if (curr.percentageCompression > 0) {
				acc[0] += 1;
				acc[1] += curr.percentageCompression;
			}
			return acc;
		}, [0, 0]);
	}
	const stats = getStats(files);
	const count = `${stats[0]}/${files.length}`;
	const saved = `${Math.round(stats[1] / (stats[0] === 0 ? 1 : stats[0]), 0)}%`;
	useEffect(() => {
		files.forEach(file => {
			file.subscribe(onUpdate);
		});
		return () => {
			files.forEach(file => {
				file.unsubscribe(onUpdate);
			});
		};
	});
	return (
		<div className={files.length <= 0 ? 'hidden' : ''}>
			<div className="table-footer-item">
				<div className="table-footer-item-title">Optimized</div>
				<div className="table-footer-item-value">{count}</div>
			</div>
			<div className="table-footer-item">
				<div className="table-footer-item-title">Saved</div>
				<div className="table-footer-item-value">{saved}</div>
			</div>
		</div>
	);
};

export default TableFooter;



// WEBPACK FOOTER //
// ./src/components/file-table/TableFooter.js